import { Component, ElementRef, Input } from "@angular/core";
import { Channel } from "app/js/src/domain/channel";
import { ContentControlLiveSource } from 'app/js/src/domain/content-control/live-source';

@Component({
  selector: "evrideo-content-control-opertation-room-channel",
  templateUrl: "./content-control-opertation-room-channel.component.html",
  styleUrl: "./content-control-opertation-room-channel.component.scss",
})
export class ContentControlOpertationRoomChannelComponent {
  @Input() channel: ContentControlLiveSource;
  dragged = false;
  constructor(private ref: ElementRef) {}
  ngOnInit() {
    this.ref.nativeElement.addEventListener(
      "dragstart",
      this.onDragStart.bind(this),
      false,
    );
    this.ref.nativeElement.addEventListener(
      "dragend",
      this.onDragEnd.bind(this),
      false,
    );
  }
  onDragStart(event) {
    event.dataTransfer.setData(
      "text/content-control-live-source-item",
      JSON.stringify(this.channel),
    );
    event.dataTransfer.dropEffect = "copy";
    this.dragged = true;
  }

  onDragEnd(event) {
    this.dragged = false;
  }
}
